// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
// import * as Page from './3-page.js';
// import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// exported variables ---------------------------------------------------------
export let fromKeyboard = false;

// local variables ------------------------------------------------------------
const headerEl = document.querySelector('.header');


// listeners function ---------------------------------------------------------
export const initListeners = () => {
  // console.log('listeners');
  
  // touch --------------------------------
  const hoverSelector = 'button, a, input';
  document.body.addEventListener('touchstart', event => { // also triggers on move
    // console.log('touchstart', event.target.classList[0]);

    // add touch hover classes
    let el = elFromEvent(hoverSelector, event);
    if (el) el.classList.add('hover');
  });

  document.body.addEventListener('touchend', event => {
    // console.log('touchend', event.target.classList[0]);

    let el = elFromEvent(hoverSelector, event);
    if (el) el.classList.remove('hover');
  });

  // touch and mouse --------------------------------
  document.body.addEventListener('click', event => { // triggers on tap, not on move
    // console.log('click', event.target.classList[0]);

    // remove focus after click
    let el = elFromEvent('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]', event);
    if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();

    el = elFromEvent('.header__logo, .js-back', event);
    if (el) { 
      event.preventDefault();

      if (headerEl && headerEl.dataset.status === 'forward') {
        headerEl.dataset.status = 'returning';
        const backwardEl = document.querySelector('.header__logo-video--backward');
        if (backwardEl) {
          backwardEl.currentTime = 0;
          backwardEl.play();
        } 
        
        setTimeout(gotoHome, 500);
      } else {
        gotoHome();
      }

      // Scroll.animateScrollTop(0, document.body, gotoHome);
    }
  });

  // keyboard --------------------------------
  document.body.addEventListener('keydown', event => {
    // console.log('keydown', event.key);
    fromKeyboard = true;
  });

  // mouse and keyboard --------------------------------
  // mouseout, focusout listeners 
  const outHandler = event => {
    // use if (event.type === 'mouseout') to avoid keyboard blur
    if (Vars.blTouch) return;
    if (event.type === 'focusout' && !fromKeyboard) return;
    // console.log('outHandler', event.target.classList[0], event.type);

    // let el = elFromEvent(swiperHoverSelector, event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }
  };

  // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button

  // mouseover, focusin listeners 
  const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
  const inHandler = event => {
    // use if (event.type === 'mouseover') to avoid keyboard focus
    if (Vars.blTouch) return;
    if (event.type === 'focusin' && !fromKeyboard) return;
    // console.log('inHandler', event.target.classList[0], event.type);

    // let el = elFromEvent(swiperHoverSelector, event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--hover');
    // }

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--drag-hor');
    // }

    // keyboard focus fixed footer, scroll there
    // if (event.type == 'focusin' && fromKeyboard && event.target.closest('.footer')) {
    //   Scroll.animateScrollTop(1000000);
    // }

    fromKeyboard = false;
  };

  // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button


  // mousedown listener --------------------------------
  document.body.addEventListener('mousedown', event => {
    // console.log('mousedown', event.target.classList[0]);

    // el = elFromEvent('.swiper-wrapper', event);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // mousemove listener --------------------------------
  document.body.addEventListener('mousemove', event => {
    // console.log('mousemove', event.target.classList[0]);

    const x = event.clientX;
    const y = event.clientY;
  }, true);

  // mouseup listener --------------------------------
  document.body.addEventListener('mouseup', event => {
    // console.log('mouseup', event.target.classList[0]);

    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // pagehide listener --------------------------------
  window.addEventListener('pagehide', event => {
    // console.log('pagehide', event);
    // Place any cleanup or transition code here

    if (headerEl) {
      cl = headerEl.classList;
      cl.remove('header--mix');
      cl.remove('header--scrolling');
      cl.remove('header--scrolled');
    }
  });
};

// functions -------------------------------------------------------------------
const gotoHome = () => {
  if (headerEl) {
    cl = headerEl.classList;
    cl.remove('header--mix');
    cl.remove('header--scrolling');
    cl.remove('header--scrolled');
  }

  setTimeout(() => {
    // no way to check if prev page was home, so we just redirect to home
    if ($pageType !== 'home') window.location.href = $baseUrl; 
  }, 100);
}
  
export const elFromEvent = (selector, event) => {
  // will return the element that matches the selector
  // returns for every sub element of the selector
  const {target} = event;
  const ancestor = target.closest(selector);
  return ancestor || target.matches(selector);
};

